import React from 'react';
import { motion } from 'framer-motion';

const Terms = () => {
  return (
    <div className="pt-32 pb-20 bg-white min-h-screen">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="space-y-12"
        >
          <div className="space-y-4">
            <h1 className="text-5xl md:text-7xl font-black text-brand-black uppercase italic tracking-tighter">
              TERMS OF <span className="text-brand-orange">SERVICE.</span>
            </h1>
            <div className="flex items-center gap-4">
              <div className="h-[1px] w-12 bg-brand-orange"></div>
              <p className="text-brand-muted font-black tracking-[0.2em] text-[10px] uppercase">Service Agreement // v3.4.0 // 2026</p>
            </div>
          </div>

          <div className="space-y-12 text-brand-black/90 leading-relaxed font-medium text-sm md:text-base">
            <section className="space-y-6">
              <h2 className="text-2xl font-black text-brand-black flex items-center gap-3">
                <span className="text-brand-orange">01.</span> ADHERENCE TO SERVICE
              </h2>
              <p>By accessing the PKRouteX platform or requesting a transport quote, you ("The Client") agree to be bound by these Terms of Service. These terms constitute a legally binding agreement between The Client and PKRouteX Logistics Solutions.</p>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-black text-brand-black flex items-center gap-3">
                <span className="text-brand-orange">02.</span> QUOTATIONS & BOOKING LOGIC
              </h2>
              <p>All quotes generated via our web interface or WhatsApp dispatch are based on current fleet availability and regional fuel index. A booking is only finalized once a <strong>Fleet Assignment ID (FAID)</strong> has been issued by our central hub. We reserve the right to reassess pricing if the actual load deviates by more than 10% from the declared weight.</p>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-black text-brand-black flex items-center gap-3">
                <span className="text-brand-orange">03.</span> FINANCIAL PROTOCOLS
              </h2>
              <p>Standard industrial payment terms apply for corporate accounts. For spot bookings:</p>
              <ul className="list-disc pl-6 space-y-3 marker:text-brand-orange">
                <li>Advance payment is required for fuel and toll clearance.</li>
                <li>Invoices are generated with HSN code 9965 (Goods transport services).</li>
                <li>G-GST compliance is mandatory for all B2B transactions.</li>
              </ul>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-black text-brand-black flex items-center gap-3">
                <span className="text-brand-orange">04.</span> OPERATIONAL BOUNDARIES
              </h2>
              <p>PKRouteX drivers and vehicles are strictly for transport. <strong>Loading and unloading are the responsibility of the client</strong> unless a manual labor add-on has been pre-booked. Vehicles will wait for a maximum of 2 hours at pickup/drop points; detention charges apply thereafter.</p>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-black text-brand-black flex items-center gap-3">
                <span className="text-brand-orange">05.</span> RISK & LIABILITY MITIGATION
              </h2>
              <p>We provide standard Transit Insurance (Marine Policy). However, PKRouteX is not liable for secondary losses, including manufacturing downtime or lost profits due to transit delays. High-value electronics and fragile industrial components must be declared for "White-Glove" handling.</p>
            </section>

            <section className="space-y-6 border-t border-black/5 pt-12">
              <h2 className="text-2xl font-black text-brand-black">GOVERNING LAW</h2>
              <p>These terms are governed by the laws of the Republic of India. Any disputes arising from these services shall be subject to the exclusive jurisdiction of the courts in Gurgaon, Haryana.</p>
              <div className="flex gap-4 mt-8">
                 <button onClick={() => window.print()} className="px-6 py-2 border border-brand-orange text-brand-orange rounded-full font-black text-xs uppercase hover:bg-brand-orange hover:text-white transition-all">Download PDF</button>
                 <button onClick={() => window.location.href = '#book'} className="px-6 py-2 bg-brand-black text-white rounded-full font-black text-xs uppercase hover:bg-brand-orange transition-all">Accept & Book</button>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Terms;
